/*
 * Payroll Page  Messages
 *
 * This contains all the text for the Payroll Page component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.PayrollPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Payroll',
  },
  monthColumnLabel: {
    id: `${scope}.monthColumnLabel`,
    defaultMessage: 'Month',
  },
  notReadyColumnLabel: {
    id: `${scope}.notReadyColumnLabel`,
    defaultMessage: 'Not ready',
  },
  readyColumnLabel: {
    id: `${scope}.readyColumnLabel`,
    defaultMessage: 'Ready',
  },
  processedColumnLabel: {
    id: `${scope}.processedColumnLabel`,
    defaultMessage: 'Processed',
  },
  filesForHeader: {
    id: `${scope}.filesForHeader`,
    defaultMessage: 'Batch/Files for',
  },
  idColumnLabel: {
    id: `${scope}.idColumnLabel`,
    defaultMessage: 'ID',
  },
  fileNameColumnLabel: {
    id: `${scope}.fileNameColumnLabel`,
    defaultMessage: 'File Name',
  },
  createdOnColumnLabel: {
    id: `${scope}.createdOnColumnLabel`,
    defaultMessage: 'Created on',
  },
  downloadStatusColumnLabel: {
    id: `${scope}.downloadStatusColumnLabel`,
    defaultMessage: 'Downloaded?',
  },
  totalSelectedLabel: {
    id: `${scope}.totalSelectedLabel`,
    defaultMessage: 'Total of Working Days selected',
  },
  createPayrollConfirmMessage: {
    id: `${scope}.createPayrollConfirmMessage`,
    defaultMessage:
      'Are you sure you want to generate Payroll files for {month} ?',
  },
  generateFilesButton: {
    id: `${scope}.generateFilesButton`,
    defaultMessage: 'Generate Payroll Files',
  },
  payrollCreated: {
    id: `${scope}.payrollCreated`,
    defaultMessage: 'Payroll files created successfully',
  },
  payrollDeleted: {
    id: `${scope}.payrollDeleted`,
    defaultMessage: 'Payroll files deleted successfully',
  },
  downloadPayrollConfirmMessage: {
    id: `${scope}.downloadPayrollConfirmMessage`,
    defaultMessage: 'Are you sure you want to download these Payroll files?',
  },
  deletePayrollConfirmMessage: {
    id: `${scope}.deletePayrollConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete these Payroll files?',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  payrollDownloaded: {
    id: `${scope}.payrollDownloaded`,
    defaultMessage: 'Payroll file downloaded successfully',
  },
});
